import { Loader } from '@googlemaps/js-api-loader';

const markers = window.markers;
const loader = new Loader({
	apiKey: window.adminAjax.google_api,
	version: 'weekly',
});


export default new class Map {
	initMap() {
		if ($('#map').length) {

			// Define styles
			var stylers = [
				{
					'featureType': 'all',
					'elementType': 'labels.text',
					'stylers': [{
						'visibility': 'on',
					}],
				},
				{
					'featureType': 'poi',
					'elementType': 'all',
				},
				{
					'featureType': 'poi.business',
					'stylers': [{
						'visibility': 'off',
					}],
				},
				{
					'featureType': 'road.arterial',
					'elementType': 'labels.icon',
					'stylers': [{
						'visibility': 'off',
					}],
				},
				{
					'featureType': 'transit',
					'elementType': 'all',
					'stylers': [{
						'visibility': 'off',
					}],
				},
				{
					'featureType': 'water',
					'elementType': 'all',
					'stylers': [{
						'color': '#46bcec',
					},
					{
						'visibility': 'on',
					},
					],
				},
				{
					'featureType': 'water',
					'elementType': 'geometry.fill',
					'stylers': [{
						'color': '#c8d7d4',
					}],
				},
				{
					'featureType': 'water',
					'elementType': 'labels.text.fill',
					'stylers': [{
						'color': '#070707',
					}],
				},
				{
					'featureType': 'water',
					'elementType': 'labels.text.stroke',
					'stylers': [{
						'color': '#ffffff',
					}],
				},
			];

			// if(window.cliConsent.functional == 'true'){
				loader
					.load()
					.then((google) => {


						// Create map
						var map = new google.maps.Map(document.getElementById('map'), {
							zoom: 13,
							mapTypeId: google.maps.MapTypeId.ROADMAP,
							maxZoom: 16,
							disableDefaultUI: true,
							styles: stylers,
						});

						// Create image marker
						var image = {
							url: '/wp-content/themes/everone/resources/assets/images/pointermap.svg',
							scaledSize: new google.maps.Size(60, 60),
						}

						// Create LatLngBounds object
						var bounds = new google.maps.LatLngBounds();
						var infowindow = new google.maps.InfoWindow();

						var i;
						if (markers) {
							for (i = 0; i < markers.length; i++) {
								var marker = new google.maps.Marker({
									map: map,
									position: new google.maps.LatLng(markers[i][0], markers[i][1]),
									optimized: false,
									icon: image,
								});

								// Extend the bounds to include each marker's position
								bounds.extend(marker.position);
								google.maps.event.addListener(marker, 'click', (function (marker, i) {
									return function () {
										if (markers[i][3]) {
											infowindow.setContent(markers[i][3])
											infowindow.open(map, marker);
										}
									}
								})(marker, i));
							}

							// Now fit the map to the newly inclusive bounds
							map.fitBounds(bounds);
						}
					})
					.catch(e => {
						// do something
						console.log(e);
					});
			// }
		}
	}
}


